import { ThunkAction } from 'redux-thunk';
import * as Bixby from '../../core';
import { AppState } from '..';
import {
  ALL_CLO_DEAL_HOLDING_FOR_BIXBYID_MAPPING_FAILURE,
  ALL_CLO_DEAL_HOLDING_FOR_BIXBYID_MAPPING_LOADING,
  ALL_CLO_DEAL_HOLDING_FOR_BIXBYID_MAPPING_SUCCESS
} from './types';
import { CloDealService } from '$/services';


export const allCloDealHoldingForBixbyIdMappingFailureAction = (error: Bixby.Models.BixbyError) => {
  return {
    type: ALL_CLO_DEAL_HOLDING_FOR_BIXBYID_MAPPING_FAILURE,
    payload: error,
    addError: true,
  };
};

export const allCloDealHoldingForBixbyIdMappingSuccessAction = (payload: Bixby.Models.CloDealHoldingForBixbyIdMapping[]) => {
  return {
    type: ALL_CLO_DEAL_HOLDING_FOR_BIXBYID_MAPPING_SUCCESS,
    payload,
  };
};

export const allCloDealHoldingForBixbyIdMappingLoadingAction = () => {
  return {
    type: ALL_CLO_DEAL_HOLDING_FOR_BIXBYID_MAPPING_LOADING,
  };
};

export const getAllCloDealHoldingForBixbyIdMappings =
  (): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => async dispatch => {
    dispatch(allCloDealHoldingForBixbyIdMappingLoadingAction());
    try {
      const data = await CloDealService.getAllCloDealHoldingForBixbyIdMappings();
      dispatch(allCloDealHoldingForBixbyIdMappingSuccessAction(data));
    } catch (error: any) {
      dispatch(allCloDealHoldingForBixbyIdMappingFailureAction(error));
    }
  };
